import defaultConfig from "../configs/default.json";

export const getConsequenceValues = (config) =>
  Object.entries((config && config.Impact) || defaultConfig.config.Impact);

export const getConsequenceName = (score, config) => {
  const consequence = getConsequenceValues(config).find((value) => Number(value[0]) === Number(score));
  return consequence ? consequence[1] : "";
};
